import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6986a742"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lishixuexi" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-img" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "course-content" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "status" }
const _hoisted_8 = {
  key: 0,
  style: {"color":"#999999"}
}
const _hoisted_9 = {
  key: 1,
  style: {"color":"#3f55f7"}
}
const _hoisted_10 = {
  key: 2,
  style: {"color":"#d69340"}
}
const _hoisted_11 = {
  key: 0,
  class: "course-detail"
}
const _hoisted_12 = { class: "course-other" }
const _hoisted_13 = { class: "first" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  style: {"color":"#f16d3d"},
  class: "iconfont icon-duoren"
}, null, -1))
const _hoisted_15 = { class: "second" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_pull_refresh, {
      modelValue: _ctx.refreshing,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.refreshing) = $event)),
      onRefresh: _ctx.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          class: "van-list",
          loading: _ctx.loading,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
          finished: _ctx.finished,
          "finished-text": "没有更多了",
          onLoad: _ctx.onLoad
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classTaskList, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "course-card",
                key: item.id,
                onClick: ($event: any) => (_ctx.openClass(item))
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_van_image, {
                    style: {},
                    width: "100%",
                    src: item.pictureUrl
                  }, null, 8, ["src"])
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(item.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_7, [
                      (item.isFinish === 1)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已学习"))
                        : (item.isFinish === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, "正在学习"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_10, "未学习"))
                    ])
                  ]),
                  (item.detail !== '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", null, _toDisplayString(item.detail), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _createTextVNode("  " + _toDisplayString(item.learnUserNum) + "人已学习 ", 1)
                    ]),
                    _createElementVNode("div", _hoisted_15, _toDisplayString(item.createDate.substr(0, 10)), 1)
                  ])
                ])
              ], 8, _hoisted_2))
            }), 128))
          ]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"])
      ]),
      _: 1
    }, 8, ["modelValue", "onRefresh"])
  ]))
}